import { h } from "preact";
import { Card, Col, DatePicker, Empty, Row, Typography } from "antd";
import { Line } from '@ant-design/plots';
import moment from "moment";

import useService from "./useService";
import ServiceInfoDataSource from "./ServiceInfoDataSource";


export default function ServiceInfoSection({ title, service_name }) {

    const { serviceInfo, fetchServiceInfo } = useService(service_name);

    const dataSource = ServiceInfoDataSource(serviceInfo);
    const serviceGraph = dataSource.asGraphView();
    const serviceStats = dataSource.asStatsView();

    const onDateRangeChange = ([dateFrom, dateTo]) => {

        if (!dateFrom || !dateTo) return;

        const date_from = dateFrom.startOf("month").unix();
        const date_to = dateTo.endOf("month").unix();

        fetchServiceInfo({ params: { date_from, date_to } });
    }

    const disabledDate = (current) => current > moment();

    const defaultValue = [moment().startOf("month"), moment().endOf("month")];

    return (
        <Card
            title={
                <Typography.Title level={4}>
                    {title}
                </Typography.Title>
            }
            style={{ marginTop: "24px" }}
            bordered={false}
            extra={
                <DatePicker.RangePicker
                    picker="month"
                    defaultValue={defaultValue}
                    disabledDate={disabledDate}
                    onCalendarChange={onDateRangeChange}
                />}
        >
            {dataSource.isEmpty() && (
                <Row justify="center">
                    <Empty
                        style={{padding: "16px"}}
                    />
                </Row>
            )}
            {!dataSource.isEmpty() && (
                <Row>
                    {serviceStats.map(({ title, key, value }, index) => (
                        <Col
                            key={key}
                            flex={1}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                borderRight: (index < serviceStats.length)
                                    ? "2px solid #F5F7FF" : "none"
                            }}
                        >
                            <div
                                style={{
                                    display: 'inline-flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography.Title
                                    level={3}
                                    style={{
                                        margin: '0 0 4px 0',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    {value}
                                </Typography.Title>
                                <Typography.Text
                                    type={"secondary"}
                                >
                                    {title}
                                </Typography.Text>
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
            {!dataSource.isEmpty() && (
                <Row style={{ display: "block" }}>
                    <Line
                        data={serviceGraph}
                        xField={"key"}
                        yField={"value"}
                        seriesField={"type"}
                        lineStyle={() => ({ opacity: 0.5 })}
                        style={{ marginTop: "16px" }}
                    />
                </Row>
            )}
        </Card>
    );
}